import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const disconnect: IMcAppType = {
  name: "disconnect_SAP",
  path: "/my-account/disconnect",
  description: "Request a disconnect for a fuel on a property",
  navFlow: NavFlow.FOCUS,
  title: "Disconnect",
  parent: Tab.MORE,
  conditions: {
    intent: "disconnect",
    customerType: CustomerType.sap,
  },
};
